var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoUser2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09688 9.44816C9.56785 9.44816 11.571 7.44505 11.571 4.97408C11.571 2.50311 9.56785 0.5 7.09688 0.5C4.62592 0.5 2.6228 2.50311 2.6228 4.97408C2.6228 7.44505 4.62592 9.44816 7.09688 9.44816Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.62594e-05 15.6708C-0.00123324 15.3563 0.0691093 15.0456 0.205675 14.7623C0.63423 13.9052 1.84275 13.4509 2.84557 13.2452C3.5688 13.0909 4.30202 12.9878 5.03977 12.9367C6.40566 12.8167 7.77944 12.8167 9.14532 12.9367C9.88301 12.9884 10.6162 13.0915 11.3395 13.2452C12.3423 13.4509 13.5509 13.8623 13.9794 14.7623C14.2541 15.3399 14.2541 16.0104 13.9794 16.5879C13.5509 17.4879 12.3423 17.8993 11.3395 18.0965C10.6171 18.2572 9.88366 18.3632 9.14532 18.4136C8.0336 18.5078 6.91669 18.525 5.8026 18.465C5.54547 18.465 5.2969 18.465 5.03977 18.4136C4.3042 18.3638 3.57352 18.2578 2.85414 18.0965C1.84275 17.8993 0.642801 17.4879 0.205675 16.5879C0.069807 16.3013 -0.000465714 15.988 -4.62594e-05 15.6708Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUser2);
export default __webpack_public_path__ + "static/media/ico-user-2.02f00d13f97a7b944bc9cf9a7f61077c.svg";
export { ForwardRef as ReactComponent };